import { RefreshCw, ShieldCheck, Timer, Users } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/Reveal";
import { useLang } from "@/lib/i18n";

const BG_IMG =
  "https://customer-assets-agu9un31.emergentagent.net/job_carpenter-pro-forte/artifacts/ll3kqblz_WhatsApp%20Image%202026-09-13%20at%2007.08.52.jpeg";
const ICONS = [ShieldCheck, Users, RefreshCw, Timer];
const TESTIDS = [
  "strength-card-sicurezza",
  "strength-card-personale",
  "strength-card-flessibilita",
  "strength-card-tempi",
];

export default function PercheSceglierci() {
  const { t } = useLang();
  const s = t.strengths;

  return (
    <section id="perche-sceglierci" className="relative overflow-hidden border-t border-[#272B36] py-28 lg:py-36">
      <div className="absolute inset-0" aria-hidden="true">
        <img src={BG_IMG} alt="" className="h-full w-full object-cover opacity-[0.14]" loading="lazy" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0D0E11] via-[#0D0E11]/85 to-[#0D0E11]" />
      </div>
      <div className="relative mx-auto max-w-7xl px-6 lg:px-10">
        <SectionHeading
          overline={s.overline}
          title={s.title}
          testid="strengths-section-title"
        />
        <div className="grid gap-6 sm:grid-cols-2 xl:grid-cols-4">
          {s.items.map((item, i) => {
            const Icon = ICONS[i];
            return (
              <Reveal key={TESTIDS[i]} delay={i * 0.08} className="h-full">
                <article
                  data-testid={TESTIDS[i]}
                  className="group relative h-full border border-[#272B36] bg-[#14161C] p-7 transition-colors duration-300 hover:border-[#F97316]/60"
                >
                  <span className="font-display text-6xl font-bold leading-none text-outline transition-colors duration-300 group-hover:[-webkit-text-stroke:1px_#E65100]">
                    0{i + 1}
                  </span>
                  <Icon className="mt-8 h-7 w-7 text-[#F97316]" strokeWidth={1.5} />
                  <h3 className="mt-4 font-display text-xl font-bold uppercase leading-tight tracking-tight text-[#F8FAFC]">
                    {item.title}
                  </h3>
                  <p className="mt-3 text-sm leading-relaxed text-[#94A3B8]">{item.desc}</p>
                </article>
              </Reveal>
            );
          })}
        </div>

        <Reveal delay={0.15}>
          <div
            data-testid="compliance-ribbon"
            className="mt-14 flex flex-wrap items-center gap-x-10 gap-y-4 border border-[#272B36] bg-[#14161C] px-7 py-5"
          >
            <span className="font-mono-tech text-[11px] font-bold uppercase tracking-[0.25em] text-[#64748B]">
              {s.ribbonLabel}
            </span>
            {s.compliance.map((c) => (
              <span key={c} className="flex items-center gap-2 text-sm font-medium text-[#94A3B8]">
                <ShieldCheck className="h-4 w-4 text-[#F97316]" strokeWidth={2} />
                {c}
              </span>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
